import { __assign } from "tslib";
import { CallType } from '../../domain';
export var createCallsApi = function (baseUrl, http) {
    var phoneCalls = baseUrl + "/phoneCalls";
    var groupsStats = baseUrl + "/stats/callGroups";
    var url = baseUrl + "/calls";
    var statsUrl = baseUrl + "/stats/calls";
    var getCallsDefaultDto = {
        callTypes: [CallType.CALLBACK, CallType.INBOUND]
    };
    var getPhoneCallsDefaultDto = {
        callTypes: [CallType.CALLBACK, CallType.INBOUND, CallType.OUTBOUND]
    };
    return {
        searchPhoneCalls: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post(phoneCalls + "/search", params);
        },
        adminSearchPhoneCalls: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post(phoneCalls + "/search/admin", params);
        },
        getGroupsStats: function (dto) {
            var params = __assign(__assign({}, getPhoneCallsDefaultDto), dto);
            return http.post(groupsStats, params);
        },
        searchCalls: function (dto) {
            var params = __assign(__assign({}, getCallsDefaultDto), dto);
            return http.post(url + "/search", params);
        },
        getOverview: function (dto) {
            var callsFilters = dto.queueId ? { queueId: dto.queueId } : dto.locale ? { locale: dto.locale } : {};
            var callTypes = dto.callTypes || getCallsDefaultDto.callTypes;
            var callsFiltersParams = __assign(__assign(__assign({}, getCallsDefaultDto), callsFilters), { callTypes: callTypes });
            return http.post(statsUrl, __assign({}, callsFiltersParams));
        }
    };
};
//# sourceMappingURL=index.js.map